import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  footer: ({ colors, typography }) => css`
    color: ${colors.neutral[400]};
    width: 100%;
    z-index: 9;
    ${typography.microCopy};
    @media (max-width: 639px) {
      text-align: center;
    }
  `,
})

export default useStyles
